import { ToggleGroup as ToggleGroupPrimitive } from "radix-ui";
import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

import { type ToggleGroupVariantProps, toggleGroupVariants } from "./toggleGroupVariants";

type ToggleGroupProps = ComponentProps<typeof ToggleGroupPrimitive.Root> & ToggleGroupVariantProps;

// Вид пунктов задаёт группа: пункты читают `data-variant` через `group-data-*`.
export const ToggleGroup = ({ className, variant = "segment", ...props }: ToggleGroupProps) => (
  <ToggleGroupPrimitive.Root
    data-slot="toggle-group"
    data-variant={variant}
    className={cn(toggleGroupVariants({ variant, className }))}
    {...props}
  />
);
